import Box from '@mui/material/Box'
import { type AppDispatch, useRoutes } from '../../../store'
import { AdCreativeEvent, AdCreativeStatus, AdCreativeWithUrls } from 'common/api/v1/types'
import { ActionMenu as BaseActionMenu } from '../../common/Table/ActionMenu'
import SettingsIcon from '@mui/icons-material/Settings'
import DeleteIcon from '@mui/icons-material/Delete'
import { useConfirmationDialog } from '../../common/ConfirmDialog'
import { deleteAdCreative } from '../../../redux/actions/adCreativeActions'
import UploadFileIcon from '@mui/icons-material/UploadFile'
interface ActionMenuProps {
  adCreative: AdCreativeWithUrls
  dispatch: AppDispatch
  onUpload: (adCreative: AdCreativeWithUrls) => void
}

export const ActionMenu = ({ adCreative, dispatch, onUpload }: ActionMenuProps) => {
  const routes = useRoutes()
  const { showConfirmation } = useConfirmationDialog()
  const pendingOrOnlyUpload =
    adCreative.status === AdCreativeStatus.pending ||
    (adCreative.events.length === 1 &&
      (adCreative.events[0] === AdCreativeEvent.uploadOk || adCreative.events[0] === AdCreativeEvent.uploadFailed))
  return (
    <Box sx={{ display: 'flex' }}>
      <BaseActionMenu
        data-test-id="input-action-menu"
        options={[
          ...(pendingOrOnlyUpload
            ? [
                {
                  icon: <UploadFileIcon />,
                  label: 'Upload File',
                  onClick: () => onUpload(adCreative),
                },
              ]
            : [
                {
                  icon: <SettingsIcon />,
                  label: 'Edit',
                  href: routes.adCreativesUpdate({ id: adCreative.id }),
                  openInNewTab: false,
                },
              ]),
          ...[
            {
              icon: <DeleteIcon />,
              label: 'Remove',
              isDestructive: true,
              onClick: () => {
                showConfirmation(
                  () => dispatch(deleteAdCreative(adCreative.id)),
                  'Are you sure you want to remove this ad creative?',
                )
              },
              'data-test-id': 'button-delete',
            },
          ],
        ]}
      />
    </Box>
  )
}
